<template>
    <div class="flex items-center justify-between">

        <div class="flex items-center">
            <img class="h-inherit" style="width:70px" :src="this.avatar"/>

            <div class="pl3">
                <h5>{{owner.name}}</h5>
                <!-- <div class="formLabel yellow">{{owner.reviewCount}} Reviews</div> -->
            </div>
        </div>
        <RatingBox :rating="owner.rating"/>

    </div>
</template>

<script>
import RatingBox from '@/components/controls/RatingBox.vue';

export default {
    props: {
        owner: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            avatar: require('@/assets/img/avatars/avatar_1.svg')
        };
    },
    components: {
        RatingBox
    }
};
</script>
